export const TRACK_TYPES = {
    MEDIA: 'media',
    OVERLAY: 'overlay',
    AUDIO: 'audio'
}

export const CLIP_SOURCE_TYPES = {
    VIDEO: 'video',
    IMAGE: 'image'
}

export const WIDGET_TYPES = {
    PLACE: 'place',
    DATETIME: 'datetime',
    WEATHER: 'weather',
    GIF: 'gif',
    MUSIC: 'music',
    HASHTAG: 'hashtag',
    MENTION: 'mention'
}

export const DEFAULT_IMAGE_DURATION_MS = 3000

// Same spirit as the Story Maker's sticker accent colors (storyMaker/main.scss
// .story-maker-sticker-menu-select .action.<type>) - kept consistent for visual continuity.
export const WIDGET_ACCENT_COLORS = {
    [WIDGET_TYPES.PLACE]: '#8034fe',
    [WIDGET_TYPES.DATETIME]: '#0096fe',
    [WIDGET_TYPES.WEATHER]: '#fe9d00',
    [WIDGET_TYPES.GIF]: '#01d454',
    [WIDGET_TYPES.MUSIC]: '#fe0067',
    [WIDGET_TYPES.HASHTAG]: '#e700c9',
    [WIDGET_TYPES.MENTION]: '#fe7102'
}

export const ASPECT_RATIOS = [
    { label: '9:16', value: 9 / 16 },
    { label: '4:5', value: 4 / 5 },
    { label: '1:1', value: 1 },
    { label: '16:9', value: 16 / 9 },
    { label: 'Original', value: null }
]

// Same idea as ImageCropper.vue's own per-network ratio menu (menuRatiosConfig), adapted for video
// formats specifically (Reels/Stories/Shorts are video-only conventions the image cropper has no
// equivalent for) - grouped by network so ClipToolPanel.vue can show (or prioritize) only the
// networks actually selected for this post instead of one flat, network-agnostic list.
export const VIDEO_RATIO_NETWORK_SECTIONS = [
    {
        network: 'instagram',
        ratios: [
            { titleKey: 'story-reels', value: 9 / 16, label: '9:16' },
            { titleKey: 'feed', value: 4 / 5, label: '4:5' },
            { titleKey: 'square', value: 1, label: '1:1' },
            { titleKey: 'landscape', value: 16 / 9, label: '16:9' }
        ]
    },
    {
        network: 'tiktok',
        ratios: [
            { titleKey: 'video', value: 9 / 16, label: '9:16' }
        ]
    },
    {
        network: 'facebook',
        ratios: [
            { titleKey: 'story-reels', value: 9 / 16, label: '9:16' },
            { titleKey: 'square', value: 1, label: '1:1' },
            { titleKey: 'video', value: 16 / 9, label: '16:9' }
        ]
    },
    {
        network: 'youtube',
        ratios: [
            { titleKey: 'shorts', value: 9 / 16, label: '9:16' },
            { titleKey: 'standard', value: 16 / 9, label: '16:9' }
        ]
    },
    {
        network: 'linkedin',
        ratios: [
            { titleKey: 'video', value: 16 / 9, label: '16:9' },
            { titleKey: 'square', value: 1, label: '1:1' }
        ]
    },
    {
        network: 'pinterest',
        ratios: [
            { titleKey: 'idea-pin', value: 9 / 16, label: '9:16' },
            { titleKey: 'standard', value: 2 / 3, label: '2:3' }
        ]
    },
    {
        network: 'twitter',
        ratios: [
            { titleKey: 'video', value: 16 / 9, label: '16:9' }
        ]
    }
]
